import React from 'react'
import { VerifyContract } from '../../pures'
import { Container } from '@material-ui/core'

const VerifyContractView = (props) => {
  return (
    <Container xs={12} lg={12} md={12} sm={12} es={12} >
      <VerifyContract />
    </Container>
  )
}

export { VerifyContractView as default }
